import _ from "underscore"

class PDFImageCache {
    constructor(){
        this.imagesCache = {}
    }

    /**
     * Preload not cached images
     * @param images map with {name: {url, saveAlpha}}
     * @returns {Promise} on images loaded
     */
    preloadImages(images)
    {
        var self = this;
        // filter names of already loaded images
        var names = _.filter(_.keys(images), function(name)
        {
            return !_.has(self.imagesCache, name);
        });

        var imagePromises = [];
        // create promises for load images
        _.each(names, function(name)
        {
            var url = images[name]["url"];
            var saveAlpha = images[name]["saveAlpha"];
            saveAlpha = _.isUndefined(saveAlpha) ? false : saveAlpha;
            imagePromises.push(self._createImagePromise(name, url, saveAlpha));
        });
        return Promise.all(imagePromises);
    }

    getImage(name)
    {
        return this.imagesCache[name];
    }

    _createImagePromise(name, url, saveAlpha)
    {
        var s = this;
        return new Promise(function(resolve)
        {
            var image = new Image();
            image["onload"] = function()
            {
                var canvas = document.createElement('canvas');
                canvas.width = this.naturalWidth; // or 'width' if you want a special/scaled size
                canvas.height = this.naturalHeight; // or 'height' if you want a special/scaled size

                var context = canvas.getContext('2d');
                context.drawImage(this, 0, 0);
                // code below needs for set white background for transparent images
                context.globalCompositeOperation = "destination-over";
                if (saveAlpha)
                {
                    context.fillStyle = "rgba(255, 255, 255, 0.0)";
                }
                else
                {
                    context.fillStyle = "#FFFFFF";
                }
                context.fillRect(0, 0, this.naturalWidth, this.naturalHeight);

                // on image load add into cache
                s.imagesCache[name] = {
                    image: canvas.toDataURL('image/' + (saveAlpha ? 'png' : 'jpeg')),
                    height: this.naturalHeight,
                    width: this.naturalWidth
                };
                resolve();
            };
            image.src = url
        });
    }
}

const instance = new PDFImageCache()

export default instance



// WEBPACK FOOTER //
// ./web/js/pdf/PDFImageCache.js